import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import type { IntlService } from 'ember-intl'
import PopoverDropdownStandard from '@blakeelearning/popovers/components/popover/dropdowns/standard'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { ActionMenu } from 'teacher-ui-client/components/base/action-menu'
import { ActionMenuItem } from 'teacher-ui-client/components/base/action-menu/item'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import type FeatureControlService from 'teacher-ui-client/services/feature-control'

interface Args {
  disabled?: boolean
  removeFromClassesModalAction: () => unknown
  exportStudentDataAction: () => unknown
  deleteStudentsModalAction: () => unknown
}

export class ManageStudentsMoreActionsComponent extends Component<Args> {
  @service intl!: IntlService

  @service session!: SessionService

  @service subscriptionType!: SubscriptionTypeService

  @service featureControl!: FeatureControlService

  get options() {
    const { usesExternalRostering } = this.session.currentSchool
    const isSubco = this.subscriptionType.current && this.session.currentTeacher.subcoFor(this.subscriptionType.current)
    return [
      {
        id: 'remove-from-all-classes',
        text: this.intl.t('manage.manageClasses.students.bulkActions.removeFromAllClasses.title'),
        action: this.args.removeFromClassesModalAction,
        hidden: usesExternalRostering || !isSubco,
      },
      {
        id: 'export-student-data',
        text: this.intl.t('manage.manageClasses.students.bulkActions.exportStudentData.title'),
        action: this.args.exportStudentDataAction,
      },
      {
        id: 'delete-students-permanently',
        text: this.intl.t('manage.manageClasses.students.bulkActions.deleteStudents.title'),
        action: this.args.deleteStudentsModalAction,
        hidden: usesExternalRostering || !isSubco,
        disabled: this.featureControl.canAccess('one_roster'),
      },
    ]
  }

  <template>
    <PopoverDropdownStandard @disabled={{@disabled}} as |dropdown _status actions|>
      <UiButton data-test-more-actions disabled={{@disabled}} aria-haspopup="menu" {{dropdown.makeTrigger}}>
        {{t "manage.manageClasses.students.bulkActions.moreActions"}}
        <PhosphorIcon @icon="phosphor-caret-down-bold" class="ml-2 h-3.5 w-3.5" />
      </UiButton>
      <dropdown.content>
        <ActionMenu data-test-more-actions-menu>
          {{#each this.options as |option|}}
            {{#unless option.hidden}}
              <ActionMenuItem
                @disabled={{option.disabled}}
                data-test-option={{option.id}}
                {{on "click" option.action}}
                {{on "click" actions.close}}
              >
                {{option.text}}
              </ActionMenuItem>
            {{/unless}}
          {{/each}}
        </ActionMenu>
      </dropdown.content>
    </PopoverDropdownStandard>
  </template>
}

export default ManageStudentsMoreActionsComponent
